/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { DEFAULT_LANGUAGE, DEFAULT_LANGUAGE_ARRAY } from "./config";
import zh from "./assets/json/zh.json";
import cn from "./assets/json/cn.json";
import en from "./assets/json/en.json";

// the translations
// (tip move them in a JSON file and import them)

function changePageKeysToUpper(obj) {
  var key, upKey;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      upKey = key.toUpperCase();
      if (upKey !== key) {
        obj[upKey] = obj[key];
        delete obj[key];
      }
    }
  }
  return obj;
}

const resources = {
  en: { translation: changePageKeysToUpper(en) },
  zh: { translation: changePageKeysToUpper(zh) },
  cn: { translation: changePageKeysToUpper(cn) },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector) // detect user language
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE, // use en if detected lng is not available

    saveMissing: true,
    keySeparator: false, // we do not use keys in form messages.welcome

    load: "currentOnly", // if get en-US, it will return en
    supportedLngs: DEFAULT_LANGUAGE_ARRAY, // renamed from whitelist in v21+
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
